import { render, staticRenderFns } from "./assistanceStu.vue?vue&type=template&id=75bc5d23"
import script from "./assistanceStu.vue?vue&type=script&lang=js"
export * from "./assistanceStu.vue?vue&type=script&lang=js"
import style0 from "./assistanceStu.vue?vue&type=style&index=0&id=75bc5d23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports